import React, {  useEffect, useState } from "react";
import { Box, Table, Tbody, Td, Text, Tr } from "@chakra-ui/react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetAllClients,fetchAsyncGetClientByID } from "redux/clientProjectSlice";
import ProjectOverview from "./Overview";
import ExpenseDetails from "./expenseDetails";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import ClientLedger from "./cleintLedger/clientLedger";
import CreditDetails from "./creditDetails";
import ClientTransactionLedger from "./transactionLedger/TransactionLedger";

const ProjectDetails = () => {

  const { id } = useParams();  
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [allClients, setAllClients] = useState([])
  
  const [clientDetails, setClientDetails] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [projectOptions,setProjectOptions] = useState([])
  const fetchClientDetails = async (clientId) => {
    try {
      const res = await dispatch(fetchAsyncGetClientByID(clientId)); 
      if (res?.payload) {
        const client = res.payload.client;
        const projects = client.prjs;
        setClientDetails(client);
        if(projects && projects?.length){
          const proOptions = await clientProjectOptions('prj','_id',projects) 
          setProjectOptions(proOptions);
        }
      }
    } catch (error) {
      addToast(`Error fetching client details:`, { appearance: "error" });
    } 
  };
  useEffect(() => {
    if (id) {
      fetchClientDetails(id);
    }
  }, [id]); 

  const fetchAllClients = async () => {
    try {
      const res = await dispatch(fetchAsyncGetAllClients()); 
      if (res?.payload) {
        setAllClients(res.payload);
      }
    } catch (error) {
      addToast(`Error fetching client details:`, { appearance: "error" });
    } 
  };

  useEffect(()=>{
    fetchAllClients();
  },[])

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const filteredClients = allClients.filter((cli) =>
    cli.clName.toLowerCase().includes(searchTerm.toLowerCase())
  );
 

  const navigate = useNavigate();

  const handleClientClick = (e,_id)=>{
    e.stopPropagation();
   
    navigate(`/client-project/${_id}`);
  }
  const [activeTab,setActiveTab] = useState('overview')
  const handleSelectTab = (k) => {
    setActiveTab(k);
  };
  return (
    <>
      <Box display="flex" className="mx-0 vendor_details">
        <Box className="vendor_details_sidebar">
          <Box className="all-vendor">
            <Text className="all-vendor-text">All Clients</Text>
          </Box>
          <Box className="vendor-item">
            <input
              className="vendor-search-field"
              placeholder="Search clients..."
              value={searchTerm}
              onChange={handleSearchChange}
              mb={4} // Margin bottom for spacing
            />
            <Table className="vendor-table">
              <Tbody>
                {filteredClients &&
                  filteredClients?.length > 0 &&
                  filteredClients?.map((item, i) => {
                    return (
                      <Tr
                        className="table-row"
                        id={i + 1}
                        onClick={(e) => {
                          handleClientClick(e, item?._id);
                        }}
                      >
                        <Td
                          className={`table-data ${
                            item?._id === id ? "active" : ""
                          }`}
                        >
                          <Box display="flex">
                            <Box className="mt-0 mx-2">
                              <input type="checkbox" id="checkbox" />
                            </Box>
                            <Box>
                              <Text
                                fontSize="14px"
                                fontWeight="500"
                                color="#000"
                              >
                                {item?.clName}
                              </Text>
                            </Box>
                          </Box>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </Box>
        </Box>
        <Box className="vendor_details_main ledger">
          <Box className="main_details-header">
            <Text color="black" fontSize="22px" fontWeight="500" mt={5} mx={3}>
              {clientDetails?.clName}
            </Text>
            <Box className="sub_tab_header">
              <div>
                <Tabs
                  defaultActiveKey={activeTab ? activeTab : "overview"}
                  transition={false}
                  id="noanim-tab-example"
                  className="add-form-tabs px-2"
                  onSelect={handleSelectTab}
                >
                  <Tab
                    eventKey="overview"
                    title="Overview"
                    className="add-form-tab mx-0"
                  >
                    <Box>
                      <ProjectOverview activeTab={activeTab} projectOptions={projectOptions} />
                    </Box>
                  </Tab>
                  <Tab
                    eventKey="expenses"
                    title="Expenses"
                    className="add-form-tab mx-0"
                  >
                    <ExpenseDetails activeTab={activeTab} projectOptions={projectOptions} />
                  </Tab>
                  <Tab
                    eventKey="creditDetails"
                    title="Credit Details"
                    className="add-form-tab mx-0"
                  >
                    <CreditDetails activeTab={activeTab} />
                  </Tab>
                  <Tab
                    eventKey="Ledger"
                    title="Ledger"
                    className="add-form-tab mx-0"
                  >
                    <ClientLedger activeTab={activeTab} projectOptions={projectOptions} clientDetails={clientDetails}/>
                  </Tab>
                  <Tab
                    eventKey="TransactionLedger"
                    title="Transaction Ledger"
                    className="add-form-tab mx-0"
                  >
                    <ClientTransactionLedger activeTab={activeTab} projectOptions={projectOptions} clientDetails={clientDetails}/>
                  </Tab>
                </Tabs>
              </div>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProjectDetails;
